import script from "./ButtonFloting.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFloting.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFloting.vue?vue&type=style&index=0&id=45b2c20e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b2c20e"]])

export default __exports__